/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom point branding. useCustomPoints false reverts to DevourPlay XP.
 * @export
 * @interface SurfacePointSystemConfigInput
 */
export interface SurfacePointSystemConfigInput {
    /**
     * 
     * @type {boolean}
     * @memberof SurfacePointSystemConfigInput
     */
    useCustomPoints?: boolean;
    /**
     * Required when useCustomPoints is true.
     * @type {string}
     * @memberof SurfacePointSystemConfigInput
     */
    pointsName?: string;
    /**
     * Asset id for the points icon. Send null to clear it; omit to leave it alone.
     * @type {string}
     * @memberof SurfacePointSystemConfigInput
     */
    pointsIconId?: string | null;
}

/**
 * Check if a given object implements the SurfacePointSystemConfigInput interface.
 */
export function instanceOfSurfacePointSystemConfigInput(value: object): value is SurfacePointSystemConfigInput {
    return true;
}

export function SurfacePointSystemConfigInputFromJSON(json: any): SurfacePointSystemConfigInput {
    return SurfacePointSystemConfigInputFromJSONTyped(json, false);
}

export function SurfacePointSystemConfigInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePointSystemConfigInput {
    if (json == null) {
        return json;
    }
    return {
        
        'useCustomPoints': json['useCustomPoints'] == null ? undefined : json['useCustomPoints'],
        'pointsName': json['pointsName'] == null ? undefined : json['pointsName'],
        'pointsIconId': json['pointsIconId'] == null ? undefined : json['pointsIconId'],
    };
}

export function SurfacePointSystemConfigInputToJSON(json: any): SurfacePointSystemConfigInput {
    return SurfacePointSystemConfigInputToJSONTyped(json, false);
}

export function SurfacePointSystemConfigInputToJSONTyped(value?: SurfacePointSystemConfigInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'useCustomPoints': value['useCustomPoints'],
        'pointsName': value['pointsName'],
        'pointsIconId': value['pointsIconId'],
    };
}

